import { render, staticRenderFns } from "./ResumoInvestimentos.vue?vue&type=template&id=1af18b79&scoped=true"
import script from "./ResumoInvestimentos.vue?vue&type=script&lang=js"
export * from "./ResumoInvestimentos.vue?vue&type=script&lang=js"
import style0 from "./ResumoInvestimentos.vue?vue&type=style&index=0&id=1af18b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af18b79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VSimpleTable})
